import { Instruction, OpCode } from '../internal.js';
/**
 * Lock Instruction.
 *
 * Locks a instance to the given pubkeyHash.
 */
export class LockInstruction extends Instruction {
    idx;
    pubkeyHash;
    constructor(idx, pubkeyHash) {
        super(OpCode.LOCK);
        this.idx = idx;
        this.pubkeyHash = pubkeyHash;
    }
}
/**
 * Lock Args Serializer object - implements the Serializable interface.
 */
export const LockArgsSerializer = {
    read(buf) {
        const idx = buf.readU16();
        const pubkeyHash = buf.readFixedBytes(20);
        return new LockInstruction(idx, pubkeyHash);
    },
    write(buf, instruction) {
        buf.writeU16(instruction.idx);
        buf.writeFixedBytes(instruction.pubkeyHash);
        return buf;
    }
};
